'use client'

import { ProductImageSliderSkeleton } from './ProductImageSliderSkeleton.client'

export function ProductImageGallerySkeleton(): React.ReactElement {
  return <ProductImageSliderSkeleton />
}
